import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

const DownloadGoodsReceiveExcel = (receiveList, companyName, setOpenBackdrop) => {
    if (!receiveList || receiveList.length === 0) {
        alert("No data found to export!");
        return;
    }

    setOpenBackdrop(true);

    try {
        const rows = [];

        // Headers with item-level details
        const headers = [
            "GRN No", "Bill No", "Order No", "Supplier", "Location", "Received By", 
            "Received Date", "Approved Status"
        ];
        rows.push(headers);

        receiveList.forEach((receipt) => {
            const safeGrn = receipt.grn_no || 'N/A';
            const safeBillNo = receipt.purchase_bill_no || 'N/A';
            const safeOrderNo = receipt.purchase_order_no || 'N/A';
            const safeSupplier = receipt.supplier_name || 'N/A';
            const safeLocation = receipt.location_address || 'N/A';
            const safeReceivedBy = receipt.staff_name || 'N/A';
            const dateValue = receipt.billing_date;
            const safeDate = dateValue && dayjs(dateValue).isValid() ? dayjs(dateValue).format("DD/MM/YYYY") : 'N/A';
            const safeApproved = receipt.is_approved || receipt.approved_status || 'N/A';
            rows.push([
                safeGrn,
                safeBillNo,
                safeOrderNo,
                safeSupplier,
                safeLocation,
                safeReceivedBy,
                safeDate,
                safeApproved
            ]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Goods Receive");

        // Set column widths
        worksheet['!cols'] = [
            { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, 
            { wch: 20 }, { wch: 18 }, { wch: 15 }, { wch: 15 },
            { wch: 25 }, { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 12 }
        ];

        XLSX.writeFile(workbook, `Goods_Receive_${new Date().getTime()}.xlsx`);
    } catch (error) {
        console.error("Excel Error:", error);
        alert("Error generating Excel!");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadGoodsReceiveExcel;
